var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link-phone",attrs:{"href":_vm.href}},[_vm._v("\n  +"+_vm._s(_vm.phone)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }